export class SfdcOpportunityCancelData {
  clientId: number;
  errorMessage: string;
  errorPopupAlert: boolean;
  orderId: number;
  sfdcOpportunityId: string;
  warningMessage: string;
  warningPopupAlert: boolean;
}
